<div>
  <section
          Pagination
          (goTo)="goToPage.emit($event)"
          [isEnd]="isEnd"
          [disable-when-fetch-data]="isLoading"
          class="book-categories-section book-cur-categories-content"
          [class.ios-header]="device.isIOS()"
  >
    <p
            *ngIf="title"
            [textContent]="title"
            id="title-slider"
    ></p>
    <div class="container">
      <ng-template
              [ngIf]="items.length > 0"
              [ngIfElse]="loading"
      >
        <ng-template
                ngFor
                [ngForOf]="items"
                let-item
                let-idx="index"
                [ngForTrackBy]="trackBy"
        >
          <ng-template
                  [ngIf]="detailMode"
                  [ngIfElse]="non_detail"
          >
            <div
                    (click)="goToBook(item.identifier, item.title, idx)"
                    class="wrapper-item"
            >
              <div class="item-img">
                <ng-template [ngIf]="showSubscriptionStatus">
                  <ng-container *ngTemplateOutlet="navaar_logo_icon_new_subscription"></ng-container>
                </ng-template>
                <img
                        [lazySrc]="IMAGE_URL + '/content/books/' +item.audioBookId +'/pic.jpg?w=250&h=250&mode=stretch&t=' +item.recordVersion"
                        lazySrcVisible="visible"
                        loading="lazy"
                        src="assets/img/placeholder.png"
                >
                <div
                        class="discount-badge"
                        *ngIf="
                                            item.products &&
                                            item.products.length > 0 &&
                                            item.products[0] &&
                                            item.products[0].price &&
                                            item.products[0].price != item.products[0].discountedPrice
                                         "
                >
                  %
                  <span [textContent]="item.products[0].discount.promotionValue * 100 | number: '1.0-0' "></span>
                </div>
              </div>
              <ng-container *ngTemplateOutlet="getTemplate(); context: { $implicit: item }"></ng-container>
            </div>
          </ng-template>
          <ng-template #non_detail>
            <div
                    class="item-non-detail"
                    [class.none]="_typeLeftContent == 'none'"
                    (click)="goToBook(item.identifier,item.title, idx)"
            >
              <div class="item-non-detail-cover">
                <img
                        [lazySrc]="IMAGE_URL + '/content/books/' +item.audioBookId +'/pic.jpg?w=250&h=250&mode=stretch&t=' +item.recordVersion"
                        lazySrcVisible="visible"
                        loading="lazy"
                        src="assets/img/placeholder.png"
                >
                <div
                        class="discount-badge"
                        *ngIf="
                                        item.products &&
                                        item.products.length > 0 &&
                                        item.products[0] &&
                                        item.products[0].price &&
                                        item.products[0].price != item.products[0].discountedPrice
                                     "
                >
                  %
                  <span [textContent]="item.products[0].discount.promotionValue * 100 | number: '1.0-0' "></span>
                </div>
              </div>
              <div class="item-non-detail-book-name truncate">
                <span [textContent]="item.title"></span>
              </div>
              <div class="item-non-detail-hit truncate">
                <ng-container *ngTemplateOutlet="getTemplate(); context: { $implicit: item }"></ng-container>
              </div>
            </div>
          </ng-template>
        </ng-template>
      </ng-template>
    </div>
  </section>
</div>
<ng-template #loading>
  <div style="direction: initial;">
    <ng-template
            ngFor
            [ngForOf]="[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]"
            let-item
    >
      <div class="catalog-page-item">
        <div class="cur-catalog-new-page-txt">
          <span class="cur-catalog-new-page-name"></span>
          <span class="cur-catalog-new-page-author"></span>
        </div>
        <div class="cur-catalog-new-page-img catalog-new-page-list">
          <img
                  src="assets/icon-new/empty-book.svg"
                  class="wrapper-img-slider"
          >
        </div>
      </div>
    </ng-template>
  </div>
</ng-template>
<ng-template
  #TemplateWithPrice
  let-item
>
  <div class="item-text TemplateWithPrice truncate">
        <span
                class="item-name"
                [textContent]="item.title"
        ></span>
    <ng-container *ngIf="item.authors">
      <div
              class="box-authors truncate"
              *ngIf="item.authors.length > 0"
      >
                <span
                        [textContent]="item.authors | combineMultipleName"
                        class="item-author"
                ></span>
      </div>
    </ng-container>
    <ng-container *ngIf="item.narrators">
      <div
              class="box-narrators truncate"
              *ngIf="item.narrators.length > 0"
      >
                <span
                        [textContent]="item.narrators | combineMultipleName"
                        class="item-narrator"
                ></span>
      </div>
    </ng-container>
  </div>
  <ng-container *ngTemplateOutlet="price; context: { $implicit: item }"></ng-container>
</ng-template>
<ng-template
  #TemplateWithStar
  let-item
>
  <div class="item-text TemplateWithStar truncate">
    <div class="item-text-header">
            <span
                    class="item-name"
                    [textContent]="item.title"
            ></span>
      <ng-container *ngTemplateOutlet="star; context: { $implicit: item }"></ng-container>
    </div>
    <ng-container *ngIf="item.authors && detailMode">
      <div
              class="box-authors truncate"
              *ngIf="item.authors.length > 0"
      >
                <span
                        [textContent]="item.authors | combineMultipleName"
                        class="item-author"
                ></span>
      </div>
    </ng-container>
    <ng-container *ngIf="item.narrators">
      <div
              class="box-narrators truncate"
              *ngIf="item.narrators.length > 0"
      >
                <span
                        [textContent]="item.narrators | combineMultipleName"
                        class="item-narrator"
                ></span>
      </div>
    </ng-container>
  </div>
</ng-template>
<ng-template
  #TemplateWithNone
  let-item
>
  <div class="item-text TemplateWithNone truncate">
        <span
                class="item-name"
                [textContent]="item.title"
        ></span>
    <ng-container *ngIf="item.authors">
      <div
              class="box-authors truncate"
              *ngIf="item.authors.length > 0"
      >
                <span
                        [textContent]="item.authors | combineMultipleName"
                        class="item-author"
                ></span>
      </div>
    </ng-container>
    <ng-container *ngIf="item.narrators">
      <div
              class="box-narrators truncate"
              *ngIf="item.narrators.length > 0"
      >
                <span
                        [textContent]="item.narrators | combineMultipleName"
                        class="item-narrator"
                ></span>
      </div>
    </ng-container>
  </div>
  <ng-template [ngIf]="showRatingNumber">
    <ng-container *ngTemplateOutlet="rating; context: { $implicit: item }"></ng-container>
  </ng-template>
  <ng-container *ngTemplateOutlet="check_subscription_status; context: { $implicit: item }"></ng-container>
</ng-template>
<ng-template
  #price
  let-book
>
  <div
          class="box-price price-container"
          *ngIf="book.products[0] && book.products[0].price"
  >
    <div
            *ngIf="book.products[0].price != book.products[0].discountedPrice"
            class="discount"
    >
      <div class="text-decoration-italic"></div>
      <div class="discounted-priced">
        <span [textContent]="(book.products[0].price / 10).toLocaleString()"></span>
        <span>تومان</span>
      </div>
    </div>
    <div class="main-price">
      <span [textContent]="(book.products[0].discountedPrice / 10).toLocaleString()"></span>
      <span>تومان</span>
    </div>
  </div>
</ng-template>
<ng-template
  #star
  let-item
>
  <div
          class="box-rate-one-star"
          *ngIf="item.rating.average"
  >
        <span
                class="number-rate"
                [textContent]="item.rating.average"
        ></span>
    <span class="image-star">
            <navaar-one-star-icon></navaar-one-star-icon>
        </span>
  </div>
</ng-template>

<ng-template
  #rating
  let-item
>
  <div
          *ngIf="item.rating"
          class="box-rate-yellow"
  >
        <span
                class="number-rate"
                [textContent]="item.rating.average || '--'"
        ></span>
  </div>
</ng-template>

<!-- <ng-template #menu>
  <span class="more-vert">
    <navaar-more-vert-icon></navaar-more-vert-icon>
  </span>
</ng-template> -->

<ng-template #check_subscription_status let-item>
  <div class="duration-container" *ngIf="showSubscriptionStatus">
    <ng-template
            [ngIf]="item.subscriptionStatus != null ? (item.subscriptionStatus.isSubscriptionConsumption && !item.subscriptionStatus.isExpired) : false">
      <navaar-lock-icon [width]="'10px'" [color]="'#ff6700'"></navaar-lock-icon>
    </ng-template>
  </div>
</ng-template>

<ng-template #navaar_logo_icon_new_subscription>
  <div class="navaar-logo-icon-show-subscription">
    <navaar-logo-simple-icon></navaar-logo-simple-icon>
  </div>
</ng-template>
